import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import type { ModalProps } from '@/core/modal/ModalContext.tsx'
import { dialogDeleteButtonSx } from '@/core/theme/style-variants.ts'

interface DeleteTabConfirmModalProps extends ModalProps<boolean> {
  tabName: string
}

export function DeleteTabConfirmModal({
  tabName,
  cancelModal,
  setModalSuccess,
}: DeleteTabConfirmModalProps) {
  return (
    <Box>
      <DialogTitle>
        Delete tab <strong>{tabName}</strong>?
      </DialogTitle>
      <DialogContent>
        <Typography>
          This will delete the tab and its filters. <strong>Cannot be undone</strong>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelModal}>Cancel</Button>
        <Button variant="contained" sx={dialogDeleteButtonSx} onClick={() => setModalSuccess(true)}>
          Delete
        </Button>
      </DialogActions>
    </Box>
  )
}
